import Collection from '../entity/Collection';

export const sortCollectionsByDate = (collections: Collection[]) => {
  return collections.sort((a, b) => {
    const aTime = new Date(a.updatedAt ?? a.createdAt ?? 0).getTime();
    const bTime = new Date(b.updatedAt ?? b.createdAt ?? 0).getTime();

    return bTime - aTime;
  });
};
